import React, { useState } from "react";
import "./Volunteer.css";

/* ================= SVG ICONS ================= */
const HandHeartIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
  </svg>
);

const UsersIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const MegaphoneIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m3 11 18-5v12L3 14v-3z" />
    <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
  </svg>
);

const BriefcaseIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </svg>
);

/* ================= COMPONENT ================= */
function Volunteer() {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    age: "",
    message: "",
  });

  const whatsappNumber = "6383551981";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleWhatsAppSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.mobile || !formData.age) {
      alert("Please fill in Name, Mobile, and Age.");
      return;
    }

    const message = `
🙋‍♂️ *New Volunteer Application*

👤 *Name:* ${formData.name}
📱 *Mobile:* ${formData.mobile}
🎂 *Age:* ${formData.age}

💬 *Message:*
${formData.message || "No additional message."}

I would like to join Anuk Charitable Trust as a volunteer.
    `;

    const encodedMessage = encodeURIComponent(message.trim());
    const url = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

    window.open(url, "_blank");
  };

  return (
    <div className="volunteer-page-wrapper">
      
      {/* ================= HERO BANNER (MATCHING SUITE STYLE) ================= */}
      <section className="volunteer-hero" style={{
    backgroundImage: "url('/images/bread.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title" style={{
    textAlign: "center"
  }}>Become a Volunteer</h1>
          <div className="hero-breadcrumb">
            <span className="breadcrumb-link">Home</span>
            <span className="breadcrumb-arrow">➔</span>
            <span className="breadcrumb-current">Volunteer</span>
          </div>
        </div>
      </section>

      {/* ================= MAIN CONTENT SECTION ================= */}
      <section className="volunteer-main-section">
        <div className="volunteer-container">
          
          {/* Introductory Section Header */}
          <div className="section-header center">
            <span className="badge-gold">JOIN THE MOVEMENT</span>
            <h2 className="main-heading">Contribute Your Unique Skills</h2>
            <p className="intro-desc">
              Your time is a precious gift. Join us in making a tangible difference. 
              Volunteering allows you to channel your compassion directly into noble, community-building causes.
            </p>
          </div>

          {/* ── MAIN GRID LAYOUT ── */}
          <div className="volunteer-grid-container">
            
            {/* Left Column: Information & Opportunities */}
            <div className="volunteer-info-column">
              
              <div className="info-card feature-highlight">
                <h3>Why Volunteer?</h3>
                <p className="lead-text">
                  Gain life-changing perspectives while creating lasting impact in Puducherry and beyond. Whether you have 1 hour or 10 hours a week, every effort counts.
                </p>
                
                <ul className="benefit-list">
                  <li>Direct connection with communities in need.</li>
                  <li>Opportunity to learn valuable field skills.</li>
                  <li>Building a stronger, highly supportive network.</li>
                </ul>
              </div>

              <div className="info-card opportunities-section">
                <h3>Available Opportunities</h3>
                
                <div className="opportunity-item">
                  <div className="opp-icon"><HandHeartIcon /></div>
                  <div className="opp-content">
                    <h4>Teaching & Mentoring</h4>
                    <p>Guide students academically or mentor youth towards better career paths. Help build confidence through education.</p>
                  </div>
                </div>

                <div className="opportunity-item">
                  <div className="opp-icon"><UsersIcon /></div>
                  <div className="opp-content">
                    <h4>Field Activities</h4>
                    <p>Get involved on the ground. Distribute food packages, assist elderly during medical camps, or organize hygiene drives.</p>
                  </div>
                </div>

                <div className="opportunity-item">
                  <div className="opp-icon"><MegaphoneIcon /></div>
                  <div className="opp-content">
                    <h4>Social Media Awareness</h4>
                    <p>Share our stories online. Raise funds through digital campaigns, create content, and spread awareness about our mission.</p>
                  </div>
                </div>

                <div className="opportunity-item">
                  <div className="opp-icon"><BriefcaseIcon /></div>
                  <div className="opp-content">
                    <h4>Event Support</h4>
                    <p>Help manage logistics for our fundraising events, galas, and community gatherings to ensure seamless operations.</p>
                  </div>
                </div>
              </div>

            </div>

            {/* Right Column: Registration Form */}
            <div className="volunteer-form-column">
              
              <div className="form-card">
                <h2>Register Interest</h2>
                <p className="form-instruction">
                  Fill out the form below. Once submitted, we will redirect you to WhatsApp where your complete application triggers directly to our coordinator.
                </p>

                <form onSubmit={handleWhatsAppSubmit}>
                  
                  <div className="input-group">
                    <label htmlFor="name">Full Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your full name"
                      required
                    />
                  </div>

                  <div className="input-row">
                    <div className="input-group half">
                      <label htmlFor="mobile">Mobile Number</label>
                      <input
                        type="tel"
                        id="mobile"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        placeholder="98765XXXXX"
                        maxLength="10"
                        required
                      />
                    </div>
                    <div className="input-group half">
                      <label htmlFor="age">Age</label>
                      <input
                        type="number"
                        id="age"
                        name="age"
                        value={formData.age}
                        onChange={handleChange}
                        placeholder="25"
                        min="16"
                        max="99"
                        required
                      />
                    </div>
                  </div>

                  <div className="input-group full">
                    <label htmlFor="message">What can you offer?</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Tell us about your unique skills, experiences, or specific field interests..."
                      rows="4"
                    ></textarea>
                  </div>

                  <button type="submit" className="submit-btn">
                    <span>Send via WhatsApp</span>
                    <span>🚀</span>
                  </button>
                  
                  <div className="privacy-note">
                    We respect your privacy. Your data is used solely for direct onboarding communication.
                  </div>

                </form>

              </div>

            </div>

          </div>

          {/* ── FOOTER TAGLINE ── */}
         

        </div>
      </section>

    </div>
  );
}

export default Volunteer;